"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHILD_ROWS_CATEGORY_KEY = 'base';
exports.CHILD_ROWS_PARENT_COMPONENT_KEY = 'table';
exports.CHILD_ROWS_COMPONENT_KEY = 'childRows';